import React from 'react';
import { AtUserAttachment } from '@/api/types';

interface AtUserTagProps {
  atUser: AtUserAttachment;
  isOwnMessage: boolean;
}

/**
 * @ 用户标签组件
 */
const AtUserTag: React.FC<AtUserTagProps> = ({ atUser, isOwnMessage }) => {
  return (
    <span
      className={`inline-flex items-center px-1.5 py-0.5 rounded text-xs font-medium ${
        isOwnMessage
          ? 'bg-blue-400 bg-opacity-50 text-blue-100'
          : 'bg-blue-100 text-blue-600'
      }`}
    >
      @{atUser.isAll ? '所有人' : atUser.name}
    </span>
  );
};

export default AtUserTag;
